import React from 'react';

import { View } from '@uncinc/react-drupal-core';

import './style.scss';

const ParagraphMilestones = ({ entity }) => {
  return (
    <div className="Paragraph ParagraphMilestones">
      <View id="milestones_overview" display="block_2" />
    </div>
  );
};

export default ParagraphMilestones;
